import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import * as actions from '../../actions';
import { connect } from "react-redux";
import { Button, Label, Input } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';

class Signin extends Component {
    handleFormSubmit = (formProps) => {
        this.props.signinUser(formProps);
    }

    renderField = ({input, label, type, meta: {touched, error, warning}}) => {
        return (
            <div>
              <Label className="sign-label">{label}</Label>
                <Input {...input} placeholder={label} type={type}/>
                {touched && ((error && <div className="error-text">{error}</div>) || (warning && <div className="warning-text">{warning}</div>))}
                <div className="spacer-lg"></div>
            </div>
        )
    }

    renderButton = (pristine, submitting) => {
        if (this.props.loading) {
            return(<Button color="success" disabled={true} type="submit">Signing In</Button>);
        } else {
            return(<Button color="success" disabled={pristine || submitting} type="submit">Submit</Button>);
        }
    }

    required = value => (value ? undefined : 'Required')
    email = value =>
      value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
        ? 'Invalid email address'
        : undefined

    render() {
        const {handleSubmit,pristine, submitting} = this.props;
        return (
            <div className="signup">
                <div className="spacer-lg"></div>
                <h3 className="add-header">Sign In</h3>
                <hr className="my-2" />
                <div className="spacer-lg"></div>
                <form onSubmit={handleSubmit(this.handleFormSubmit)}>
                    <Field name="email" type="email" component={this.renderField} label="Email" validate={[this.required,this.email]}/>
                    <Field name="password" type="password" component={this.renderField} label="Password" />
                    <div className="spacer-lg"></div>
                  <div>
                    {this.renderButton(pristine, submitting)}
                  </div>
                </form>
            </div>
        )
    }
}

function mapStateToProps(state) {
  return { loading: state.app.loading };
}

const reduxSignin =  reduxForm({
  form: 'Signin'
})(Signin);

export default connect(mapStateToProps, actions)(reduxSignin);



// WEBPACK FOOTER //
// ./src/pages/auth/signin.js